import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CompanySchema = withDefaults({
  type: 'company',
  traits: ['commentable'],
  fields: [
    {
      kind: 'attribute',
      name: 'publicTheme',
    },
    {
      kind: 'attribute',
      name: 'companyType',
    },
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'launchDate',
    },
    {
      kind: 'attribute',
      name: 'programTitle',
    },
    {
      kind: 'attribute',
      name: 'legacyId',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'taEnabled',
    },
    {
      kind: 'attribute',
      name: 'root',
    },
    {
      kind: 'hasMany',
      name: 'plans',
      type: 'plan',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasProgramTemplates',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'hasMany',
      name: 'eligibilityFileJobLogs',
      type: 'eligibility-file-job-log',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'conditions',
      type: 'condition',
      options: {
        async: false,
        inverse: 'conditionable',
        as: 'conditionable',
      },
    },
    {
      kind: 'hasMany',
      name: 'matchPlans',
      type: 'match-plan',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'belongsTo',
      name: 'companySetting',
      type: 'company-setting',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfGroups',
      type: 'pslf-group',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'logo',
      type: 'public-asset',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'schedules',
      type: 'schedule',
      options: {
        async: false,
        inverse: 'owner',
        as: 'owner',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasGroups',
      type: 'tas-group',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'hasMany',
      name: 'customCompanyEmailTemplates',
      type: 'custom-company-email-template',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'hasMany',
      name: 'fileHistories',
      type: 'file-history',
      options: {
        async: false,
        inverse: 'company',
      },
    },
    {
      kind: 'hasMany',
      name: 'postalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'ownedPostalAddresses',
      type: 'postal-address',
      options: {
        async: false,
        inverse: 'postalAddressable',
        as: 'postal-addressable',
      },
    },
    {
      kind: 'belongsTo',
      name: 'partnerPolicy',
      type: 'partner-policy',
      options: {
        async: false,
        inverse: 'company',
      },
    },
  ],
});

export default CompanySchema;
